// Module
var code = "<div class=\"row panel panel-default\" ng-class=\"{'panel-no-box-shadow' : isHideBorder || internalIsCollapsed}\"> <div class=\"col-md-12\"> <div ng-transclude> </div> </div> </div>";
// Exports
module.exports = code;